import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';

import { environment } from '../../../environments/environment';
import { createErrorResponse } from '../utils';
import { SimpleResponse } from '../types';
import { BackendShareholder } from './types';

const ASSOCIATES_URL = `${environment.api}/v2/associates/`;

@Injectable({
  providedIn: 'root',
})
export class ShareholdersService {
  constructor(private http: HttpClient) {}

  public async updateShareholders(
    associates: Omit<BackendShareholder, 'id'>[],
  ): Promise<SimpleResponse<BackendShareholder[]>> {
    try {
      const response = await lastValueFrom(
        this.http.post<BackendShareholder[]>(ASSOCIATES_URL, associates),
      );

      return {
        data: response,
      };
    } catch (error) {
      /**
       * FIXME: We should use a more specific error message provided by the backend
       * Backend will return a better error message after this issue is resolved:
       * https://equipolegalbot.atlassian.net/browse/LB-1288
       */
      return createErrorResponse(
        Error(
          'Error al actualizar los accionistas. Asegúrate de que exista a lo menos uno y que no hayas repetido algún rut',
        ),
      );
    }
  }
}
